/**
 * Created by mqamhieh on 10/8/17.
 */
window.TalentAssessmentAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['TalentAssessmentServer']);

    self.registerForAssessment = function (brandId, jobId, appId, message) {
        var defer = $q.defer();

        _protected.request("brands/" + brandId + "/candidates", "POST", {
            application_id: appId,
            job_id: jobId,
            message: message
        }).then(function (res) {
            if (res && res.status === 200 && res.data) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res.data)
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getAssessmentStatusForUsers = function (brandId, jobId, usersIds) {
        var defer = $q.defer();

        _protected.request("brands/" + brandId + "/jobs/" + jobId + "/statuses", "GET", { user_ids: usersIds })
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    for (var i in res.data.data.candidates) {
                        var assessStatus = res.data.data.candidates[i];
                        var deadline = new Date(assessStatus.deadline_date);

                        if (assessStatus.status != TalentAssessmentAPI.STATUSES.COMPLETED && deadline.getTime() < Date.now()) {
                            assessStatus.status = TalentAssessmentAPI.STATUSES.EXPIRED;
                        }
                    }
                    defer.resolve(res.data.data.candidates);
                } else {
                    defer.reject(res)
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getCandidateStatusDetails = function (brandId, CEBCandidateId) {
        var defer = $q.defer();

        _protected.request("brands/" + brandId + "/candidates/" + CEBCandidateId, "GET")
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    var assessStatus = res.data.data;
                    var deadline = new Date(assessStatus.deadline_date);

                    for (var i in assessStatus.assessments) {
                        if (assessStatus.assessments[i].status != TalentAssessmentAPI.STATUSES.COMPLETED && deadline.getTime() < Date.now()) {
                            assessStatus.assessments[i].status = TalentAssessmentAPI.STATUSES.EXPIRED;
                            assessStatus.status = TalentAssessmentAPI.STATUSES.EXPIRED;
                        }
                    }

                    defer.resolve(assessStatus);
                } else {
                    defer.reject(res)
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.cancelCandidateAssessments = function (brandId, CEBCandidateId) {
        var defer = $q.defer();

        _protected.request("brands/" + brandId + "/candidates/" + CEBCandidateId, "DELETE")
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res)
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };
});

TalentAssessmentAPI.STATUSES = {
    NOT_SENT: 'NOT_SENT',
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    EXPIRED: 'EXPIRED'
};